import DateTime from '@/core/components/presentationStandards/DateTime'
import { ColumnDef } from '@/core/components/table/types.ts'
import { Notification } from '@/modules/utilities/notification/types/notification.ts'
import { Typography } from '@mui/material'

const UseColumns = () => {
  const columns: ColumnDef<Notification>[] = [
    {
      field: 'message',
      headerName: 'Mensaje',
      renderCell: (field, record) => {
        const leido = record.requestStatus === 'LEÍDA'
        return (
          <Typography
            component="span"
            sx={{
              fontWeight: !leido ? 'bold' : 'normal',
              color: !leido ? 'text.primary' : 'text.secondary',
              transition: 'all 0.3s ease'
            }}
          >
            {field}
          </Typography>
        )
      }
    },
    {
      field: 'createdAt',
      headerName: 'Tiempo',
      renderCell: (field) => (
        <DateTime field={field} isoDate outputFormat="DD/MM/YYYY HH:mm:ss" />
      )
    }
  ]

  return { columns }
}

export default UseColumns
